import { Command, CommandResult } from '../procedure.interface';
import { Device } from '@/device';
import { InstallProperties } from '@/interfaces/properties.interface';
import { Logger } from '@/logger';

export class ShellCommand implements Command {
  public command: string;
  public stopOnError: boolean;
  public type: string;

  constructor(command: string, stopOnError: boolean = false) {
    this.stopOnError = stopOnError;
    this.type = 'shell';
    this.command = command;
  }

  public toLog(): string {
    return this.command;
  }

  public async execute(device: Device, _logger: Logger, _?: InstallProperties): Promise<CommandResult> {
    const { code, logs } = await device.sendCommand(this.command);
    return Promise.resolve({
      success: code === 0,
      message: logs,
    });
  }
}
